import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "rgb(222, 197, 189)",
  },
  contentContainer: {
    alignItems: "center",
    gap: 20,
    paddingHorizontal: 20,
  },
  title: {
    fontSize: 28,
    fontWeight: "bold",
    textAlign: "center",
    marginVertical: 20,
  },
  inputLabel: {
    fontSize: 20,
    fontWeight: "bold",
    alignSelf: "flex-start",
  },
  input: {
    width: "100%",
    padding: 10,
    backgroundColor: "white",
    borderRadius: 8,
    fontSize: 16,
  },
  button: {
    padding: 15,
    borderRadius: 8,
    width: "100%",
  },
  buttonText: {
    color: "white",
    textAlign: "center",
    fontSize: 16,
  },
  responseContainer: {
    width: "100%",
    marginTop: 20,
  },
  responseLabel: {
    fontSize: 16,
    fontWeight: "bold",
  },
  responseText: {
    marginTop: 10,
    backgroundColor: "white",
    padding: 10,
    borderRadius: 8,
  },
  statusButton: {
    backgroundColor: "#4A90E2",
  },
  printButton: {
    backgroundColor: "#50C878",
  },
  clearButton: {
    backgroundColor: "#E74C3C",
  },
});
